
<!-- <div class="spinner-box">
  <div class="three-quarter-spinner"></div>
</div> -->

<div class="spinner-box">
  <img src="/assets/images/logo_animated.gif"
       alt="loader"
       class=""/>
</div>

